import { Navigate, useParams } from 'react-router-dom';
import { useGetModeloProducto } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveModeloProductos } from '../../shared/saveModeloProducto';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateModeloProductoPageInterface {}

const UpdateModeloProductoPage: React.FC<UpdateModeloProductoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_modelo)

  const { id } = useParams();
  const { data, isLoading } = useGetModeloProducto(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_modelo) return <Navigate to="/inventario/modelo-productos" />;

  return <SaveModeloProductos titlePage="Editar Modelo productos" editModeloProducto={data.data} />;
};

export default UpdateModeloProductoPage;
